<template>
    <div>
        <deal-list-row v-for="deal in $root.deals" :key="deal.id" :deal="deal" />
    </div>
</template>

<script>
    import DealListRow from './partials/DealListRow.vue';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'DealList',

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            DealListRow
        }
    }
</script>

